import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { applicationState } from 'shared/store/applicationState'
import { formatDateTime, toISOLocalDate } from "shared/models/mapping/mapping";
import { Toggle } from "components/ui/ToggleContent";
import { PageList } from "components/ui/PageList";
import { Chip } from "@mui/material";
import { FilterArrow } from 'components/portal/GridComponents';
import { ToggleButton } from 'components/ui/ToggleButton';

import {
    ChevronRight as LinkIcon,
    ArrowDownward as SortDescIcon,
    ArrowUpward as SortAscIcon,
    ImportExport as SortNoneIcon,
    NearMeOutlined,
    SupervisorAccountOutlined
} from '@mui/icons-material';
import { GNHView } from './DrivingExemptionView';
import { gnhAdminSummaryDashboardOverview, gnhUsersSubmittedFormList } from './DrivingExemptionPageSelector';
import { drivingExemptionOverviewPathRoute, gnhUsersSubmittedFormListRoute } from './DrivingExemptionRoutes';
import { DrivingExemptionAudit, DrivingExemptionStatusEnum, UserDrivingExemptionList } from '../../../shared/models/api/models';
import { getAdminDrivingExemptionList, getUserDrivingExemptionList } from '../../../shared/services/drivingExemptionApi';
import DrivingExemptionPage from './DrivingExemptionPage';
import { ExemptionFormTypeEnum, ExemptionFormTypeEnumToString } from '../../../shared/enums/exemption-form-type-enum';
import { ISelectOption } from '../forms/util';


enum OrderByOption {
    NameAsc,
    NameDesc,
    StartTimeAsc,
    StartTimeDesc
}

interface TitleProps {
    title: string
}

const TitleContainer = (props: TitleProps) => {
    return (
        <div className="fa-list-title">
            <div className="fa-list-title-text">{props.title}</div>
        </div>
    );
}


interface IPageSizeDropdownProps {
    pageSize: number,
    setPageSize: (pageSize: number) => void,
    defaultExpanded?: boolean,
    sizes: number[]
}

const PageSizeDropdown = (props: IPageSizeDropdownProps) => {
    return (
        <span className="psl-list-container">
            <div className="psl-list">
                {props.sizes.map(s =>
                    <div key={s}
                        className={`psl-item${s === props.pageSize ? " selected" : ""}`}
                        onClick={() => props.setPageSize(s)}>{s} items</div>
                )}
            </div>
        </span>
    );
}

const PageSizeWithPicker = (props: IPageSizeDropdownProps) => {
    return (
        <Toggle label={props.pageSize + " items"} collapseOnChangeOf={props.pageSize}>
            <PageSizeDropdown {...props} />
        </Toggle>
    );
};


interface ResultCountProps {
    viewCount: number,
    resultCount: number,
    pageSize: number,
    setPageSize: any,
    link?: string,
    visible?: boolean
}

const ResultCountContainer = (props: ResultCountProps) => {

    if (!props.visible) {
        return (<></>);
    }

    return (
        <div className="fa-list-resultcount float-right">
            {props.link &&
                <Link to={props.link} className="fa-list-resultcount-link">
                    <span className="fa-list-resultcount-text">{props.viewCount} of {props.resultCount} results</span>
                    <LinkIcon />
                </Link>
            }
            {!props.link &&
                <div className="fa-list-resultcount-itemsPerPage">
                    <span className="picker">
                        <PageSizeWithPicker
                            pageSize={props.pageSize}
                            setPageSize={props.setPageSize}
                            sizes={[10, 25, 50, 100]} />
                    </span>
                    <span> per page of {props.resultCount} results</span>
                </div>
            }
        </div>
    );
}

export const DrivingExemptionStatusEnumToString = ((option: DrivingExemptionStatusEnum) => {
    switch (option) {
        case DrivingExemptionStatusEnum.Requested:
            return 'Submitted';
        case DrivingExemptionStatusEnum.InitialReviewApproved:
            return 'Endorsed';
        case DrivingExemptionStatusEnum.DeptManagerApproved:
            return 'DM Approved';
        case DrivingExemptionStatusEnum.GMApproved:
            return 'GM Approved';
        case DrivingExemptionStatusEnum.InitialReviewRejected:
            return 'Declined';
        case DrivingExemptionStatusEnum.DeptManagerRejected:
            return 'DM Declined';
        case DrivingExemptionStatusEnum.GMRejected:
            return 'GM Declined';
        case DrivingExemptionStatusEnum.Approved:
            return 'Approved';
        case DrivingExemptionStatusEnum.Expired:
            return 'Expired';
        case DrivingExemptionStatusEnum.InitialReviewCancelled:
            return 'Initial Review Incompleted';
        case DrivingExemptionStatusEnum.FinalReviewCancelled:
            return 'Final Review Incompleted';
        default: 'NA'
    }
});
const monthDiff = (dateFrom: Date, dateTo: Date) => {
    return dateTo?.getMonth() - dateFrom?.getMonth() +
        (12 * (dateTo?.getFullYear() - dateFrom?.getFullYear()));
    console.log(dateTo?.getMonth() - dateFrom?.getMonth() + (12 * (dateTo?.getFullYear() - dateFrom?.getFullYear())));
};

interface FaListProps {
    loading: boolean,
    adminView?: boolean,
    currentView: GNHView,
    assessments: UserDrivingExemptionList[],
    pageNumber: number,
    pageSize: number,
    orderByOption: OrderByOption,
    orderByName: any,
    orderByStartDateTime: any,
    orderByEndDateTime: any,
    orderByStatus: any
}

const FaListContainer = (props: FaListProps) => {
    const [displayAssessments, setDisplayAssessments] = useState(props.assessments.slice(0, props.pageSize));
    const [formOptions, setFormOptions] = useState([] as string[]);
    const [formFilter, setFormFilter] = useState([] as ExemptionFormTypeEnum[]);

    const navigate = useNavigate();

    const nameOrderIcon = () => {
        if (props.orderByOption === OrderByOption.NameAsc) {
            return (<SortDescIcon />);
        }
        else if (props.orderByOption === OrderByOption.NameDesc) {
            return (<SortAscIcon />);
        }
        return (<SortNoneIcon />);
    }

    const startTimeOrderIcon = () => {
        if (props.orderByOption === OrderByOption.StartTimeAsc) {
            return (<SortDescIcon />);
        }
        else if (props.orderByOption === OrderByOption.StartTimeDesc) {
            return (<SortAscIcon />);
        }
        return (<SortNoneIcon />);
    }
    const filterForm = ((forms: string[]) => {
        if (forms.length === 0 || forms[0] === 'All') {
            setFormFilter([]);
            return;
        }

        let newForms = [] as ExemptionFormTypeEnum[];

        forms.map(r => {
            let formValue = Object.keys(ExemptionFormTypeEnum)[Object.values(ExemptionFormTypeEnum).indexOf(r)];
            newForms.push(parseInt(formValue));
        });

        setFormFilter(newForms);

    });

    useEffect(() => {
        let start = (props.pageNumber - 1) * props.pageSize;

        let newDisplayAssessments = props.assessments.slice(start, start + props.pageSize);

        if (formFilter.length > 0) {
            newDisplayAssessments = newDisplayAssessments.filter((item) => formFilter.includes(item.formTypeEnum || 0))
        }

        setDisplayAssessments(newDisplayAssessments);

        setFormOptions(
            props.assessments
                .filter((item, i, arr) => arr.findIndex(a => a.formTypeEnum === item.formTypeEnum) === i)
                .map(a => (a.formTypeEnum || 0) as number)
                .sort()
                .map(r => ExemptionFormTypeEnum[r])
        );
    }, [props.assessments, props.pageNumber, props.pageSize, formFilter]);

    const getActionPath = (audithistory: DrivingExemptionAudit[]) => {
        const url = `/drivingExemption/details/${props.adminView === true ? "ExemptionsDashboard" : "MyForm"}`;
        navigate(url, { state: audithistory });
    }

    return (
        <div className="fa-list-body">
            {props.loading === true ?
                <div className="p-4 text-center">Loading...</div>
                :
                <>
                    <div className="row assessment-card-row">
                        <div className="de-col de-col-form"> <FilterArrow text="Form" filterItems={formOptions} onFilter={filterForm} /></div>
                            {props.adminView === true && <>
                            <div className="de-col de-col-medium" onClick={props.orderByName}>Name {nameOrderIcon()}</div>
                            </>}
                        <div className="de-col de-col-date" onClick={props.orderByStartDateTime} >Requested Date {startTimeOrderIcon()}</div>

                        <div className="de-col de-col-narrow" onClick={props.orderByStatus}>Status {nameOrderIcon()}</div>

                        <div className="de-col de-col-wide" >ActionedBy</div>

                        <div className="de-col de-col-on-behalf">Submitted on-behalf</div>

                        <div className="de-col de-col-date" onClick={props.orderByEndDateTime}>End Date {startTimeOrderIcon()}</div>

                        <div className="de-col de-col-comment">Comment</div>                        
                    </div>
                    <div className="fatigue-assessment-divider row"></div>
                        {(displayAssessments !== undefined && displayAssessments.length > 0) ? displayAssessments.map((user, id) => (
                            <>
                                <div className="row align-items-center assessment-card assessment-card-row" onClick={() => getActionPath(user.exemptionHistory)} style={{ cursor: 'pointer' }} >
                                    <div className="de-col de-col-form"> {ExemptionFormTypeEnumToString(user.formTypeEnum)} </div>
                                    {props.adminView === true && <>
                                        <div className="de-col de-col-medium"> {user.user.fullname} </div>
                                    </>}
                                    <div className="de-col de-col-date">{formatDateTime(user.requestDate)}</div>

                                    <div className={`de-col-narrow ${user.status === DrivingExemptionStatusEnum.Approved ? "approved" : {}}`}> {DrivingExemptionStatusEnumToString(user.status)} </div>
                                    <div className="de-col de-col-wide">{user.actionedBy}</div>
                                    <div className="de-col de-col-on-behalf">{(user.submittedOnBehalf ? "True" : "")}</div>
                                    <div className={`de-col-date ${monthDiff(new Date(), new Date(user?.endDate)) <= 3 ? "expiring" : {}}`}>{formatDateTime(user.endDate)}</div>
                                    <div className="de-col de-col-comment" title={user.comment}>{user.comment}</div>
                                </div>

                            </>

                        ))
                            :
                            <div>
                                <div >
                                    <div className="p-4 text-center">There are no actionable Driving Exemptions to display.</div>
                                </div>
                            </div>
                        }
                </>
            }
        </div>
    );
}


interface FooterProps {
    pageNumber: number,
    pageSize: number,
    totalResults: number,
    moveToPage: any,
    visible?: boolean
}

const FooterContainer = (props: FooterProps) => {

    if (!props.visible) {
        return (<></>);
    }

    return (
        <div className="fa-list-footer">
            <div className="page-list">
                <PageList {...props} />
            </div>
        </div>
    );
}

interface DrivingExemptionDashboardProps {
    page: ISelectOption,
    pageView: GNHView,
    showPageSize?: boolean,
    showHeaderLink?: boolean,
    showFilters?: boolean,
    showFooter?: boolean
}
const DrivingExemptionDashboard = (props: DrivingExemptionDashboardProps) => {
    const [selectedPage] = useState(props.page ?? gnhUsersSubmittedFormList);
    const [pageView] = useState(props.pageView ?? GNHView.MyForm);
    const [currentView, setCurrentView] = useState(props.pageView);
    const [assessmentCacheTime, setAssessmentCacheTime] = useState(new Date().getTime());
    const [assessments, setAssessments] = useState(undefined as UserDrivingExemptionList[] | undefined);
    const [viewAssessments, setViewAssessments] = useState([] as UserDrivingExemptionList[]);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(25);
    const [pageNumber, setPageNumber] = useState(1);
    const [headerLink, setHeaderLink] = useState(undefined as string | undefined);
    const [adminView, setAdminView] = useState(false);
    const [orderByOption, setOrderByOption] = useState(OrderByOption.StartTimeAsc);
    const [loadBackground, setLoadBackground] = useState(false);

    const dateTimeFormat = new Intl.DateTimeFormat("en-AU", {});

    const getPageTitle = () => {
        var title = selectedPage.label;
        return title;
    }

    const pageTitle = getPageTitle();

    const getViewData = async () => {
        setAssessmentCacheTime(new Date().getTime());
        let items: UserDrivingExemptionList[] = [];

        if (currentView === GNHView.MyForm) {
            items = await getUserDrivingExemptionList();
            setAdminView(false);
            setAssessmentCacheTime(new Date().getTime());
            return items;
        }
        else if (currentView === GNHView.Overview) {
            items = await getAdminDrivingExemptionList();
            setAdminView(true);
            setAssessmentCacheTime(new Date().getTime());
            return items;
        }
        setAssessmentCacheTime(new Date().getTime());
        return items;
    }

    const orderByName = () => {
        let data: UserDrivingExemptionList[] = assessments ? [...assessments] : [];

        data.sort((a, b) => {
            let aName = a.user?.fullname || "";
            let bName = b.user?.fullname || "";
            return aName.localeCompare(bName);
        }
        );

        let sortBy = OrderByOption.NameAsc;
        if (orderByOption == OrderByOption.NameAsc) {
            sortBy = OrderByOption.NameDesc;
            data.reverse();
        }
        setOrderByOption(sortBy);
        setViewAssessments(data);
    }
    const orderByStatus = () => {
        let data: UserDrivingExemptionList[] = assessments ? [...assessments] : [];

        data.sort((a, b) => {
            let aName = DrivingExemptionStatusEnumToString(a.status) || "";
            let bName = DrivingExemptionStatusEnumToString(b.status) || "";
            return aName.localeCompare(bName);
        }
        );

        let sortBy = OrderByOption.NameAsc;
        if (orderByOption == OrderByOption.NameAsc) {
            sortBy = OrderByOption.NameDesc;
            data.reverse();
        }
        setOrderByOption(sortBy);
        setViewAssessments(data);
    }

    const orderByRequestedDateTime = () => {
        let data: UserDrivingExemptionList[] = assessments ? [...assessments] : [];

        data.sort((a, b) => {
            let aTime = a.startDate || Date.now;
            let bTime = b.startDate || Date.now;
            if (aTime < bTime) return -1;
            if (aTime > bTime) return 1;
            return 0;
        }
        );

        let sortBy = OrderByOption.StartTimeAsc;
        if (orderByOption == OrderByOption.StartTimeAsc) {
            sortBy = OrderByOption.StartTimeDesc;
            data.reverse();
        }

        setOrderByOption(sortBy);
        setViewAssessments(data);
    }

    const orderByEnddDateTime = () => {
        let data: UserDrivingExemptionList[] = assessments ? [...assessments] : [];

        data.sort((a, b) => {
            let aTime = a.endDate || Date.now;
            let bTime = b.endDate || Date.now;
            if (aTime < bTime) return -1;
            if (aTime > bTime) return 1;
            return 0;
        }
        );

        let sortBy = OrderByOption.StartTimeAsc;
        if (orderByOption == OrderByOption.StartTimeAsc) {
            sortBy = OrderByOption.StartTimeDesc;
            data.reverse();
        }

        setOrderByOption(sortBy);
        setViewAssessments(data);
    }

    const configHeaderLink = () => {
        if (!props.showHeaderLink) {
            return;
        }

        let link = undefined as string | string[] | undefined

        if (currentView === GNHView.MyForm) {
            link = gnhUsersSubmittedFormListRoute.path;
        }
        else if (currentView === GNHView.Overview) {
            link = drivingExemptionOverviewPathRoute.path;
        }

        if (typeof (link) === 'string') {
            setHeaderLink(link);
        }

    }

    const moveToPage = (page: number) => {
        setPageNumber(page);
    }

    const updateCurrentView = (view: GNHView) => {
        setAssessments(undefined);
        setCurrentView(view);
    }

    useEffect(() => {
        let mounted = true;
        const mount = async () => {
            setLoading(true);
            const items = await getViewData();
            configHeaderLink();

            if (mounted && Array.isArray(items)) {
                setAssessments(items);
                setViewAssessments(items);
                setLoading(false);
            }
        };

        if (!assessments) {
            mount();
        }

        return () => { mounted = false; };
    }, [currentView, viewAssessments]);

    useEffect(() => {
        let mounted = true;
        const mount = async () => {
            const items = await getViewData();
            if (mounted && Array.isArray(items)) {
                setAssessments(items);
                setViewAssessments(items);
            }
            setLoadBackground(false);
        }

        if (loadBackground) {
            mount();
        }

        return () => { mounted = false; };
    }, [loadBackground]);

    useEffect(() => {
        const pollingSeconds = 60;
        const cacheAgeThreshold = 50;
        const interval = setInterval(() => {
            if (currentView !== GNHView.MyForm && assessmentCacheTime < new Date().getTime() - (cacheAgeThreshold * 1000)) {
                setLoadBackground(true);
            }
        }, pollingSeconds * 1000);
        return () => {
            clearInterval(interval);
        }
    }, []);

    return (
        <>
            <DrivingExemptionPage selectedPage={(currentView === GNHView.Overview) ?gnhAdminSummaryDashboardOverview:gnhUsersSubmittedFormList}>
                <div className="fa-list-container">
                    <TitleContainer
                        title={pageTitle} />

                    <ResultCountContainer
                        viewCount={viewAssessments.length}
                        resultCount={viewAssessments.length}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        link={headerLink}
                        visible={true} />


                    <FaListContainer
                        loading={loading}
                        assessments={viewAssessments}
                        adminView={adminView}
                        currentView={currentView}
                        pageNumber={pageNumber}
                        pageSize={pageSize}
                        orderByOption={orderByOption}
                        orderByName={orderByName}
                        orderByStartDateTime={orderByRequestedDateTime}
                        orderByEndDateTime={orderByEnddDateTime}
                        orderByStatus={orderByStatus}
                    />

                    <FooterContainer
                        visible={true}
                        pageNumber={pageNumber}
                        pageSize={pageSize}
                        totalResults={viewAssessments.length}
                        moveToPage={moveToPage}
                    />
                </div>
            </DrivingExemptionPage>
        </>
    );
}

export default DrivingExemptionDashboard;
